import { Components, Theme } from '@mui/material';

export const MuiTypographyStyle: Components<Theme>['MuiTypography'] = {
  defaultProps: {
    color: 'textPrimary',
  },
};
